import { cn } from '@bem-react/classname';

export const cnMap = cn('Map');
